module.exports = __webpack_public_path__ + "img/logo-france-2.svg";